module.exports = __webpack_public_path__ + "img/rlsb_summary_Image.aaea55fb.png";